import React from "react";
import Chart from "react-google-charts";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII, ICreditInquiries } from "../../../store/businessCreditReportService/types";
import moment from "moment-timezone";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const CreditSummaryReportInquery: React.FunctionComponent<IProps> = (props) => {
    let chartData = [["Month", "Score"]];
    let isLoading = !props.showAsAccordion;

    let dataForChart = [];
    dataForChart.push(["Month", "Score"]);

    let creditInquiries = props.reportObject?.businessCompanyReport?.credit_inquiries;
    if (creditInquiries) {
        creditInquiries.sort(function (a: ICreditInquiries, b: ICreditInquiries) {
            let aScoreTime = moment(a.week_start_date, "MM/DD/YYYY").toDate().getTime();
            let bScoreTime = moment(b.week_start_date, "MM/DD/YYYY").toDate().getTime();
            return aScoreTime - bScoreTime;
        });

        creditInquiries.forEach((score) => {
            if (score.number_of_inquiries && score.number_of_inquiries !== "--" && score.week_start_date && score.week_start_date !== "--") {
                dataForChart.push([moment(score.week_start_date, "MM/DD/YYYY").format("MMM DD, YYYY"), Number(score.number_of_inquiries)]);
            }
        });

        chartData = dataForChart;
        isLoading = false;
    } else {
        isLoading = false;
    }

    var options = {
        title: "",
        hAxis: {
            title: "",
            titleTextStyle: {
                color: "#333",
            },
            textPosition: "none",
        },
        pointSize: 5,
        vAxis: {
            minValue: 0,
            baselineColor: "#fff",
            gridlineColor: "#fff",
            textPosition: "none",
        },
        colors: ["#37A954"],
        height: 120,
        legend: {
            position: "none",
        },
        tooltip: {
            isHtml: true,
        },
        chartArea: {
            left: 8,
            top: 5,
            bottom: 16,
            right: 8,
            width: "100%",
            height: "100%",
        },
        series: {
            0: {
                type: "AreaChart",
                areaOpacity: 0.1,
            },
        },
    };

    return (
        <React.Fragment>
            <div className="row full-width between-xs margin-bottom-l payment-table-header">
                <div className="col-xs flex-grow-null">
                    <h4 className="content-sub-title">Credit Inquiries</h4>
                </div>
            </div>
            {isLoading ? (
                <div className="box loading"></div>
            ) : (
                <React.Fragment>
                    {chartData && chartData.length > 1 ? (
                        <div className="credit-score-trend-chart" style={{ minHeight: "8rem" }}>
                            <div id="chart-credit-trend" className="m-chart-container"></div>
                            <Chart chartType="AreaChart" loader={<div>Loading Chart</div>}
                                    data={chartData} options={options} rootProps={{ "data-testid": "2" }}
                                    chartEvents={[
                                        {
                                            eventName: "ready",
                                            callback: ({ chartWrapper, google }) => {
                                                window.addEventListener(
                                                    "keydown",
                                                    (event) => {
                                                        if (event.key !== "Escape") return;
                                                        event.stopPropagation();
                                                        window.showtoolTip();
                                                    },
                                                    true
                                                );
                                                var chart = new google.visualization.AreaChart(document.getElementById("chart-credit-trend"));
                                                var svg = chart.getContainer().getElementsByTagName("svg");
                                                if (svg.length > 0) {
                                                    svg[0].setAttribute('role', 'img');
                                                    svg[0].setAttribute("aria-label", "Credit Score Tracker Bar Graph");
                                                }
                                            },
                                        },
                                    ]}
                                />
                        </div>
                    ) : (
                        <div className="box">
                            <div className="box-content text-align-center">There is no Business Credit Inquiries data.</div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default CreditSummaryReportInquery;
